const InsuranceReportTypes = {
	/****************  GET INSURANCE REPORT START ********************** */
	FETCH_INSURANCE_REPORT_START: 'fetch_insurance_report_start',
	FETCH_INSURANCE_REPORT_SUCCESS: 'fetch_insurance_report_success',
	FETCH_INSURANCE_REPORT_FAILURE: 'fetch_insurance_report_failure',
	FETCH_INSURANCE_REPORT_RESPONSE_RESET_START: 'fetch_insurance_report_response_reset_start',
	FETCH_INSURANCE_REPORT_RESPONSE_CHANGED: 'fetch_insurance_report_response_reset_changed',
	/****************  GET INSURANCE REPORT END ********************** */
};
export default InsuranceReportTypes;
